export enum LocationType {
  REGION = 'region__slug',
  COUNTRY = 'country__slug',
  CITY = 'city__slug',
}

export interface FromCityPayload {
  citySlug: string;
  regionSlug?: string;
  countrySlug?: string;
}
